export enum StrapiError {
  CURRENT_PASSWORD_INVALID = 'The provided current password is invalid',
}
